import { Row, Col, Form } from "react-bootstrap";

function AtencionesControles({
  motivos,
  motivoSeleccionado,
  onChangeMotivo,
  orden,
  onChangeOrden,
}) {
  return (
    <Row className="mb-3">
      {/* Filtro por motivo */}
      <Col xs={12} md={6}>
        <Form.Label className="mb-0">Motivos</Form.Label>
        <Form.Select
          value={motivoSeleccionado}
          onChange={(e) => onChangeMotivo(e.target.value)}
        >
          {motivos.map((motivo, idx) => (
            <option key={idx} value={motivo}>
              {motivo}
            </option>
          ))}
        </Form.Select>
      </Col>

      {/* Orden por fecha */}
      <Col xs={12} md={6}>
        <Form.Label className="mb-0">Ordenar por</Form.Label>
        <Form.Select
          value={orden}
          onChange={(e) => onChangeOrden(e.target.value)}
        >
          <option value="desc">Más recientes primero</option>
          <option value="asc">Más antiguos primero</option>
        </Form.Select>
      </Col>
    </Row>
  );
}

export default AtencionesControles;
